import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/navigation/sidebar'
import { Topbar } from '@/components/navigation/topbar'
import { BottomNav } from '@/components/navigation/bottom-nav'
import { RequestFab } from '@/components/requests/request-fab'

export function OperationsLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-cream">
      <Sidebar role="estate_manager" portalLabel="Operations Portal" />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-8 pb-24 lg:pb-8">
          <Outlet />
        </main>
      </div>
      <BottomNav role="estate_manager" />
      <RequestFab />
    </div>
  )
}
